<template>
    <div>
    <transition
            enter-active-class="transition duration-400 ease-in"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-100 ease-out"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            class="h-full"
        >
            <div v-if="savingChanges" class="fixed top-0 bottom-0 left-0 right-0 bg-black/[0.7] flex flex-col justify-center items-center z-1000"
                    tabindex="-1" >
                <div class="flex flex-col justify-center items-center p-4 rounded-md">
                <svg aria-hidden="true" class="mx-1 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#d3d3d3"/>
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#2E9CCA"/>
                </svg>
                <div class="text-white p-4 whitespace-nowrap text-sm">
                    Please wait while we save your changes.
                </div>
                </div>
            </div>
        </transition>
        <div class="flex h-[85vh] flex-col space-y-10">
            <div class="w-full px-1 pt-1 pr-2 fixed bg-neutral-200 flex flex-col">
                <div class="w-full h-10 bg-neutral-50 flex items-center justify-between shadow-md rounded m-1 space-x-4">
                    <div class="flex items-center space-x-4 justify-self-start pl-2">
                        <div class="w-fit">
                            <PaginationLoader
                                class="rounded-full hover:bg-gray-300"
                                @refetch-results="loadCompanies"
                                :isLoading="isLoading"
                              ></PaginationLoader>
                        </div>
                    <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Client:
                            </div>
                        </div>
                        <select v-model="clientId" class="bg-gray-50 p-1 h-3/4 rounded-r border-2 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                            <option :value="null">------</option>    
                            <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.client_name }}</option>
                        </select>
                    </div>
                    <!-- <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Responsible:
                            </div>
                        </div>
                        <select v-model="userId" class="bg-gray-50 p-1 h-3/4 rounded-r border-2 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                            <option :value="null">------</option>    
                            <option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
                        </select>
                    </div> -->
                    <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Next Step:
                            </div>
                        </div>
                        <select v-model="nextStepId" class="bg-gray-50 p-1 h-3/4 rounded-r border-2 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="">
                            <option :value="null">------</option>    
                            <option v-for="crmDetail in crmDetailTypes" :key="crmDetail.id" :value="crmDetail.id">{{ crmDetail.unresolved_label }}</option>
                        </select>
                    </div>
                    <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Due Date:
                            </div>
                        </div>
                        <div class="bg-gray-50 p-1 flex items-center rounded-r border-2">
                            <input type="date" @change="setDueDate" :value="dueDate" class="bg-gray-50  text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="" />
                            <input class="ml-1" @input="setDueThisWeek" v-model="thisWeek" :value="true" type="checkbox">
                            <div class="flex ml-1 items-center">
                                This Week
                            </div>
                        </div>
                    </div>
                    <div class="flex text-xs">
                        <div class="rounded-l-md bg-gray-300 flex items-center p-1">
                            <div class="flex items-center">
                                Show All:
                            </div>
                        </div>
                        <div class="bg-gray-50 p-1 flex items-center rounded-r border-2">
                            <input class="ml-1" @input="showAll" v-model="showAllOpenDetails" :value="true" type="checkbox">
                        </div>
                    </div>
                    <div class="card flex justify-center">
                        <Button type="button" pt:root="hover:bg-gray-300 rounded-md hover:cursor-pointer p-1" :unstyled="true" @click="toggle"><BulkOperationSVG /></Button>

                        <Popover ref="op">
                            <div class="grid p-2 grid-cols-2 gap-2">
                                <!-- <div @click="setBulkAction('responsible')" class="p-1 active:bg-gray-400 rounded-lg border-2 hover:cursor-pointer hover:bg-gray-200 flex items-center justify-center">
                                    Edit Next Step Responsible
                                </div>
                                <div @click="setBulkAction('details')" class="p-1 active:bg-gray-400 rounded-lg border-2 hover:cursor-pointer hover:bg-gray-200 flex items-center justify-center">
                                    Edit Next Step Details
                                </div> -->
                                <base-button @click="setBulkAction('responsible')" >
                                    Edit Next Step Responsible
                                </base-button>
                                <base-button @click="setBulkAction('details')" >
                                    Edit Next Step Details
                                </base-button>
                            </div>
                            <base-dialog-box v-if="bulkAction" @close="clearBulkAction">
                                <template #header>
                                <h2>Bulk Action: {{ bulkAction.title }}</h2>
                                </template>
                                <template #body>
                                <CrmDetailSpreadsheetBulkOps
                                    :bulk-action="bulkAction"
                                    :selected-results="selectedDetails"
                                    :user-options="userOptions"
                                    @close-bulk-operation="clearBulkAction"
                                    @refetch-results="loadCompanies"
                                ></CrmDetailSpreadsheetBulkOps>
                                </template>
                            </base-dialog-box>
                        </Popover>
                    </div>
                    <!-- <div
                        class="rounded-md hover:bg-gray-300 p-1 hover:cursor-pointer"
                        ref="bulkOperationsBoundary"
                        title="Bulk Operations"
                        @click="toggleShowBulkOperations"
                    >
                        <BulkOperationSVG />
                    </div> -->
                    </div>
                </div>
            </div>
            <div v-if="companies" class="p-4 w-full h-full overflow-auto">
                <base-table>
                    <template #table-header>
                    <base-table-header :key="header.value" :header="header.value" class="-top-1.5" :class="header.class" v-for="header in tableHeadersList">
                      <div class="flex items-center justify-between space-x-1">
                        <div>
                          {{ header.value }}
                        </div>
                      </div>
                    </base-table-header>
                    </template>
                    <template #table-body>
                        <UserCrmDetailsSpreadsheetRow v-for="company in filteredCompanies"
                         :selected-details="selectedDetails"
                         :campaigns="campaigns"
                         :crm-statuses="crmStatusOptions"
                         :key="company.id" :crm-detail-types="crmDetailTypes"
                         :user-options="userOptions"
                         :company="company"
                         :show-all-open="showAllOpenDetails"
                         @add-selected-detail="addSelectedDetail"
                         @remove-selected-detail="removeSelectedDetail"
                         @refetch-companies="loadCompanies"/>
                    </template>
                </base-table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { getCrmSpreadsheetCompanies } from '@/services/Company';
import { getActions } from '@/services/CrmAction';
import { useToast } from 'vue-toast-notification';
import PaginationLoader from '../base-components/PaginationLoader.vue';
import UserCrmDetailsSpreadsheetRow from './UserCrmDetailsSpreadsheetRow.vue';
import { getUsers } from '@/services/User';
import { getClients } from '@/services/Client';
import { getCrmStatuses } from '@/services/CrmStatus';
import { getCampaigns } from '@/services/Campaign';
import { getTodaysDateAsString } from '@/composables/formatDate';
import { sortCRMDetailsByDueDate as sortByDueDate } from '@/composables/CompanyCRMTools';
import { createUserInteractionLog } from '@/services/UserInteractionLog';
import BulkOperationSVG from '../svg-components/BulkOperationSVG.vue';
import { Button, Popover } from 'primevue';
import CrmDetailSpreadsheetBulkOps from './CrmDetailSpreadsheetBulkOps.vue';


const store = useStore()
const $toast = useToast()
const companies = ref(null)
const isLoading = ref(false)
const actionsToAdd = ref([])
const actionsToUpdate = ref([])
const companiesToUpdate = ref([])
const crmDetailTypes = ref([])
const crmStatus = ref(null)
const campaigns = ref([])
const crmStatusOptions = ref([])
const clientId = ref(null)
const userId = ref(null)
const nextStepId = ref(null)
const dueDate = ref(null)
const clients = ref([])
const userOptions = ref([])
const changesList = ref([])
const selectedDetails = ref([])
const savingChanges = ref(false)
const showAllOpenDetails = ref(false)
const showActiveOnly = ref(true)

function showAll(){
    showAllOpenDetails.value = !showAllOpenDetails.value
}


async function loadActions() {
    const token = store.state.auth.token
    const response = await getActions(token)
    // console.log('response', response.data)
    crmDetailTypes.value = response.data
}

const op = ref();

const toggle = (event) => {
    op.value.toggle(event);
}

async function loadClients() {
    const result = await getClients({ token: store.state.auth.token, endpoint: '?get_all=true' });
    clients.value = result.data;
}


const selectedDetailsLength = computed(() => {
    return selectedDetails.value.length
})

const crmDetailSpreadsheetBulkOperations = computed(() => {return {
    editResponsible: {
        label: 'Edit Next Step Responsible',
        modelPath: 'crm_details',
        endpoint: 'bulk_update_crm_detail_user',
        message: `Please select the user to assign as responsible for the next step for the ${selectedDetailsLength.value} selected companies.`
    },
    editNextStepDetails: {
        label: 'Edit Next Step Details',
        modelPath: 'crm_details',
        endpoint: 'bulk_update_crm_detail_notes',
        message: `Please add the next step detail for the ${selectedDetailsLength.value} selected companies.`,
    }
}
})


async function setDueDate(event) {
    dueDate.value = event.target.value
    if(dueDate.value){
        const token = store.state.auth.token 
        const data = {
            log_title: "CRM Details Spreadsheet: Specific Date Selected",
            log_detail: "User selected a specific date to filter CRM Details on the spreadsheet view",
            user: store.state.auth.user.id
        }
        const result = await createUserInteractionLog(data, token)
        // console.log('result', result)
    }
    
}

function addSelectedDetail(detailId){
    const crmDetail = selectedDetails.value.find((id) => id == detailId)
    if(!crmDetail){
        selectedDetails.value.push(detailId)
    }
}

function removeSelectedDetail(detailId){
    const crmDetailIndex = selectedDetails.value.findIndex((id) => id === detailId)
    if(crmDetailIndex != -1){
        selectedDetails.value.splice(crmDetailIndex, 1)
    }
}


async function loadCrmStatuses(){
    const token = store.state.auth.token
    const result = await getCrmStatuses(token)
    crmStatusOptions.value = result
    // console.log('crm options', crmStatusOptions.value)
}
async function loadCampaigns(){
    const token = store.state.auth.token
    const result = await getCampaigns(token)
    campaigns.value = result
  }

const showBulkOperations = ref(false)

function toggleShowBulkOperations(){
    showBulkOperations.value = !showBulkOperations.value
}

function setBulkAction(action){
    if(selectedDetails.value.length > 0){
        if(action === 'responsible'){
            bulkAction.value = crmDetailSpreadsheetBulkOperations.value.editResponsible
        }
        if(action === 'details'){
            bulkAction.value = crmDetailSpreadsheetBulkOperations.value.editNextStepDetails
        }
    }

}

const tableHeadersList = ref([
    {value: '', class: "w-10"},
    {value: 'Client', class: ""},
    {value: 'Coverage', class: ""},
    {value: 'Target', class: ""},
    {value: 'CRM Status', class: ""},
    {value: 'Next Step', class: ""},
    {value: 'Due Date', class: ""},
    {value: 'Next Step Detail', class: "w-screen"},
    {value: 'Responsible', class: ""},
])



const changeCount = computed(() => {
    return actionsToAdd.value.length + actionsToUpdate.value.length + companiesToUpdate.value.length
})

watch(clientId, () => {
    loadCompanies()
})

watch(crmStatus, () => {
    loadCompanies()
})



function getCompanyNextAction(company){
    if(company.crm_actions.length > 0){
        let openActions = company.crm_actions.filter((action) => {
            return !action.resolved_date && action.campaign_id == company.campaign.id
        })
        if(openActions.length > 0){
            openActions = openActions.sort(sortByDueDate)
            return openActions[0]
        } else {
            return null
        }
    } else {
        return null
    }
}

const bulkAction = ref(null)

function clearBulkAction(){
    bulkAction.value = null
}

function getSunday(d) {
  d = new Date(d);
  let day = d.getDay(),
    diff = d.getDate() - day
  return new Date(d.setDate(diff));
}

function getStaturday(d) {
  d = new Date(d);
  let day = d.getDay(),
    diff = d.getDate() - day + 6
  return new Date(d.setDate(diff));
}


const filteredCompanies = computed(() => {
    let filterCompanies = companies.value
    if(userId.value){
        filterCompanies = filterCompanies.filter((company) => {
            const nextAction = getCompanyNextAction(company)
            if(nextAction){
                return nextAction.user && nextAction.user.id == userId.value
            } else {
                return false
            }
        })
    }
    if(nextStepId.value){
        filterCompanies = filterCompanies.filter((company) => {
            const nextAction = getCompanyNextAction(company)
            if(nextAction){
                return nextAction.action && nextAction.action.id == nextStepId.value
            } else {
                return false
            }
        })
    }
    if(dueDate.value){
        filterCompanies = filterCompanies.filter((company) => {
            const nextAction = getCompanyNextAction(company)
            if(nextAction){
                return nextAction.due_date && nextAction.due_date == dueDate.value
            } else {
                return false
            }
        })
    }
    if(thisWeek.value){
        let today = new Date()
        let sunday = getSunday(today)
        let saturday = getStaturday(today)
        filterCompanies = filterCompanies.filter((company) => {
            const nextAction = getCompanyNextAction(company)
            if(nextAction){
                return nextAction.due_date && new Date(nextAction.due_date) >= sunday && new Date(nextAction.due_date) <= saturday
            } else {
                return false
            }
        })
        
    }
    return filterCompanies
})

async function loadCompanies(){
    const token = store.state.auth.token
    let queryParams = `crm_spreadsheet_users=${store.state.auth.user.id}`
    // let queryParams = ''
    // if(crmStatus.value){
    //     queryParams += `&crm_status=${crmStatus.value}`
    // }
    if(clientId.value){
        queryParams += `&client_drf=${clientId.value}`
    }
    isLoading.value = true
    const result = await getCrmSpreadsheetCompanies(token, queryParams)
    // console.log('result', result)
    if(result.status == 200){
        companies.value = result.data.companies
        isLoading.value = false
        actionsToAdd.value = []
        actionsToUpdate.value = []
        selectedDetails.value = []
        companiesToUpdate.value = []
        isLoading.value = false
    }
}

const thisWeek = ref(false)

async function setDueThisWeek(){
    thisWeek.value = !thisWeek.value
    if(thisWeek.value){
        const token = store.state.auth.token 
        const data = {
            log_title: "CRM Details Spreadsheet: This Week Selected",
            log_detail: "User selected 'This Week' to filter CRM Details on the spreadsheet view",
            user: store.state.auth.user.id
        }
        const result = await createUserInteractionLog(data, token)
        // console.log('result', result)
    }
}

watch(thisWeek, () => {
    if(thisWeek.value){
        dueDate.value = null
    }
})

watch(dueDate, () => {
    if(dueDate.value){
        thisWeek.value = false
    }
})


async function setUserOptions() {
    let payload = {
        token: store.state.auth.token,
        endpoint: '?group_id=1&group_id=7&group_id=8&exclude_dev=True&is_active=True'
    }
    const result = await getUsers(payload)
    userOptions.value = result.users
}

function addOrEditActionToAdd(action){
    const actionIndex = actionsToAdd.value.findIndex((actionToAdd) => actionToAdd.id == action.id)
        if(actionIndex >= 0){
            actionsToAdd.value[actionIndex] = action
        } else {
            actionsToAdd.value.push(action)
        }
        // console.log('actions to add', actionsToAdd.value)
}

function addOrEditActionToUpdate(action){
    if(actionsToAdd.value.findIndex((actionToAdd) => actionToAdd.id == action.id) >= 0){
        addOrEditActionToAdd(action)
    } else {
        const actionIndex = actionsToUpdate.value.findIndex((actionToUpdate) => actionToUpdate.id == action.id)
        if(actionIndex >= 0){
            actionsToUpdate.value[actionIndex] = action
        } else {
            actionsToUpdate.value.push(action)
        }
        console.log('actions to update', actionsToUpdate.value)
    }
}

function updateNextStep(companyId, detailData){
    const company = companies.value.find((company) => company.id == companyId)
    const nextAction = company.crm_actions.find((crmDetail) => crmDetail.id == detailData.detailId)
    const changeData = {
        companyId: companyId,
        detailId: detailData.detailId,
        field: detailData.field,
        oldValue: nextAction[detailData.field],
        newValue: detailData.value
    }
    nextAction[detailData.field] = detailData.value
    console.log('changed company', company)
    changesList.value.push(changeData)
    addOrEditActionToUpdate(nextAction)
}

function createNewNextStep(companyId, detailId, newDetailData){
    const company = companies.value.find((company) => company.id == companyId)
    const nextAction = company.crm_actions.find((crmDetail) => crmDetail.id == detailId)
    const changeData = {
        companyId: companyId,
        detailId: detailId,
        field: 'resolved_date',
        oldValue: nextAction.resolved_date,
        newValue: getTodaysDateAsString()
        // newValue: new Date().toISOString().split('T')[0]
    }
    nextAction.resolved_date = getTodaysDateAsString()
    // nextAction.resolved_date = new Date().toISOString().split('T')[0]
    addOrEditActionToUpdate(nextAction)
    company.crm_actions.push(newDetailData)
    addOrEditActionToAdd(newDetailData)
}

loadCompanies()
loadActions()
setUserOptions()
loadClients()
loadCampaigns()
loadCrmStatuses()

</script>